import * as React from "react";
import queryString from 'query-string';
import { Container, Row, Col } from 'reactstrap';
import {Icon, Breadcrumb, Button, Carousel, Badge, Popover, Avatar, Modal} from 'antd';
import ArticleService from "../../Services/articleService";
import { blobToSRC, formatDate } from "../../util/UtilFunction";
import { FileType } from "../../APIModels/FileParam";
import FileService from "../../Services/fileService";
import Spin from "antd/lib/spin";
import htmlToDraft from "html-to-draftjs";
import {EditorState} from "draft-js";
import ContentState from "draft-js/lib/ContentState";
import {Editor} from "react-draft-wysiwyg";
import alertService from "../../Services/alertService";

export class DetailArticle extends React.Component {
    constructor(props) {
        super(props)

        let params = queryString.parse(this.props.location.search);
        this.props.showUserBadge(false);
        this.state = {
            user: this.props.token,
            id: params.id,
            article: null,
            images: [],
            audios: [],
            pages: [],
            loaderImg: false,
            loaderAudio: false,
            loaderPages: false,
            editorState: EditorState.createEmpty(),
            modalOpen: false,
            modalTitle: '',
            modalId: '',

        }

        this.articleService = new ArticleService(this.state.user)
        this.fileService = new FileService(this.state.user)

        this.setModal = this.setModal.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
       this.fetchArticleById(this.state.id)
    }

    fetchArticleById(id) {
        this.props.loader(true)
        this.articleService.getArticle(id)
            .then((response) => {
                const blocksFromHtml = htmlToDraft(response.data.data.text);
                const { contentBlocks, entityMap } = blocksFromHtml;
                const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                const editorState = EditorState.createWithContent(contentState);
                this.setState({
                    article: response.data.data,
                    editorState: editorState,
                }, (() => this.getFile()))
                this.props.loader(false)
            }).catch((err) => {
                console.log(err);
                this.props.loader(false)
            })
    }

    getFile = async () => {
        if (!this.state.article.files)
            return

        let imgs = this.state.article.files.filter(f => f.type === FileType.Image);
        let audios = this.state.article.files.filter(f => f.type === FileType.Audio);
        let pages = this.state.article.files.filter(f => f.type === FileType.Page);

        if (imgs.length > 0) {
            this.setState({ loaderImg: true})
            const imgsPromise = imgs.map(img => {

                return new Promise((resolve) => {
                    this.fileService.downloadFile(img.id)
                        .then(resp => {
                            var reader = blobToSRC(resp.data)
                            reader.onload = async () => {
                                let base64 = reader.result
                                img.src = base64
                                resolve(img);
                            };
                        })
                })
            })

            const imgsWithSrc = await Promise.all(imgsPromise);
            this.setState({ loaderImg: false, images: imgsWithSrc.reverse() })
        }

        if (audios.length > 0) {
            this.setState({ loaderAudio: true })
            const audiosPromise = audios.map(audio => {
                return new Promise((resolve) => {

                    this.fileService.downloadFile(audio.id)
                        .then(resp => {
                            const blob = new Blob([resp.data], { type: 'audio/mpeg' });
                            const url = window.URL.createObjectURL(blob);
                            audio.src = url
                            resolve(audio);
                        })

                })
            })

            const audiosWithSrc = await Promise.all(audiosPromise);
            this.setState({ loaderAudio: false, audios: audiosWithSrc.reverse() })
        }

        if (pages.length > 0) {
            this.setState({ loaderPages: true })
            const pagesPromise = pages.map(page => {
                return new Promise((resolve) => {

                    this.fileService.downloadFile(page.id)
                        .then(resp => {
                            const blob = new Blob([resp.data], { type: 'application/pdf' });
                            const url = window.URL.createObjectURL(blob);
                            page.src = url
                            resolve(page);
                        })

                })
            })

            const pagesWithSrc = await Promise.all(pagesPromise);
            this.setState({ loaderPages: false, pages: pagesWithSrc })
        }
    }

    goBack() {
        return window.open("/archive/articles", '_self');
    }

    goToEdition(id, e){
        e.stopPropagation();
        window.open('/archive/edition/detail?id=' + id, "_self" )
    }

    goToPrevious(e) {
        e.stopPropagation();
        window.open('/archive/article/detail?id=' + this.state.article.previousArticleId, "_self")
    }

    goToNext(e) {
        e.stopPropagation();
        window.open('/archive/article/detail?id='  + this.state.article.nextArticleId, "_self")
    }

    deleteArticle(id) {
        this.articleService.deleteArticle(id)
            .then((response) => {
                if(response.data && response.data.ok){
                    alertService.setAlert('success', 'Article delete')
                    window.open('/archive/articles', "_self" )
                }

            } )
            .catch((err) => console.log(err))
    }

    setModal(value, title, id) {
        this.setState({ modalOpen: value, modalTitle: title, modalId: id })
    }

    handleOk(id) {
        this.setState({ modalOpen: false, modalTitle: '', modalId: null })
        this.deleteArticle(id)
    }

    handleCancel() {
        this.setState({ modalOpen: false, modalTitle: '', modalId: null })
    }



    render() {
        let modal =
            <Modal title={'Delete article'} visible={this.state.modalOpen} onOk={() => this.handleOk(this.state.modalId, this.state.modalTitle)} onCancel={() => this.handleCancel()}>
                <p>Delete article: {this.state.modalTitle}?</p>
            </Modal>

        return (this.state.article &&

            <Container fluid={true}>
                <Row>
                    <Col sm="12" style={{display: 'inline-flex', height: '0', justifyContent: "end"}}>
                        <Breadcrumb className="bread" style={{left: 24}}>
                            <Breadcrumb.Item>
                                <Button className="fmk_button primary mr-2" style={{bottom: 3}} onClick={() => this.goBack()}>
                                    <Icon type="caret-left" />
                                </Button>
                                <strong className="h5 font-weight-bold" style={{color: 'black'}}>View article</strong>
                            </Breadcrumb.Item>
                        </Breadcrumb>
                        <div className="plusButtonCat">
                            <Badge>
                                <Popover placement="bottomRight" content={this.props.usercontent} trigger="click">
                                    <div style={{cursor: 'pointer'}}>
                                        <Avatar style={{backgroundColor: this.props.avatarColor, marginLeft: '5px'}}
                                                icon="user"/>
                                    </div>
                                </Popover>
                            </Badge>
                        </div>
                    </Col>
                    <Col style={{minHeight: '50vh'}} sm='12' className="my-5">
                        <div className="wizardFields wizardContacts p-0" style={{minHeight: '50vh'}}>
                            <div className="wizardBackground createCat" style={{height: 'inherit'}}>
                                <div className="modifyHrBox" style={{width: '100%'}}>
                                    <Row>
                                        <Col sm="9" className="pr-5">
                                            <div className="article-navigation">
                                                <button
                                                    className="fmk_button n_button secondary mb-2"
                                                    onClick={(e) => this.goToPrevious(e)}
                                                    disabled={!this.state.article.previousArticleId}
                                                >
                                                    <div className="button-content">
                                                        <span className="arrow">←</span>
                                                        <span className="button-text">Previous Article</span>
                                                    </div>
                                                </button>

                                                <button
                                                    className="fmk_button n_button secondary mb-2 ml-2"
                                                    onClick={(e) => this.goToNext(e)}
                                                    disabled={!this.state.article.nextArticleId}
                                                >
                                                    <div className="button-content">
                                                        <span className="button-text">Next Article</span>
                                                        <span className="arrow">→</span>
                                                    </div>
                                                </button>
                                            </div>


                                            {this.state.article.occhiello && (
                                                <p>{this.state.article.occhiello}</p>
                                            )}
                                            <h3>{this.state.article.title}</h3>
                                            <p className="lead">{this.state.article.summary}</p>

                                            {this.state.images.length > 0 && (
                                                <Carousel className="p-4" slidesToShow={3} infinite={false} arrows={true} draggable={true}>
                                                    {this.state.images.map(img => {
                                                        return (
                                                            <div key={img.id}>
                                                                <div className="d-flex justify-content-center position-relative">
                                                                    <img className="articleImg" src={img.src} />
                                                                </div>

                                                                <p className="p-2" style={{ marginLeft: "9%" }}>{img.description}</p>
                                                            </div>
                                                        )
                                                    })}
                                                </Carousel>
                                            )}
                                            <Editor editorState={this.state.editorState} toolbarClassName="d-none" />
                                            <p className="font-italic">{this.state.article.signature}</p>
                                            <p className="text-center">Page: {this.state.article.pageFrom} - {this.state.article.pageTo}</p>
                                        </Col>
                                        <Col sm="3" className="mt-2">
                                            <p className="h5 font-weight-bold" style={{color: 'black'}}>Details</p>
                                            <p>Status: <strong>{this.state.article.isOnline ? 'Online' : 'Offline'}</strong>
                                            </p>
                                            <p>Magazine: <strong>{this.state.article.edition.magazine.name}</strong></p>
                                            <p>Edition:
                                                <strong className="fmk_link ml-1" style={{cursor: 'pointer'}}
                                                        onClick={(e) => this.goToEdition(this.state.article.edition.id, e)}>
                                                    {this.state.article.edition.number}
                                                </strong>
                                            </p>
                                            <p>Topic: <strong>{this.state.article.category.name}</strong></p>
                                            <p>Tag: <strong>{this.state.article.tags.toString()}</strong></p>
                                            <p>Created
                                                by {this.state.article.userCreated},
                                                date: {formatDate(this.state.article.created)}
                                            </p>
                                            {this.state.article.lastUpdate && (
                                                <p>Last update
                                                    by {this.state.article.userUpdated},
                                                    date: {formatDate(this.state.article.lastUpdate)}
                                                </p>
                                            )}
                                            <a className="fmk_button secondary mt-2"
                                               href={"/archive/articles/edit?id=" + this.state.article.id}>
                                                <Icon type="edit" className="mx-2"/>
                                                Edit article
                                            </a>
                                            <button className="fmk_button secondary mt-4 ml-2"
                                                    onClick={(e) => this.setModal(true, this.state.article.title, this.state.article.id)}>
                                                <Icon type="delete" className="mx-2"/>
                                                Delete article
                                            </button>
                                            <br/>
                                        </Col>
                                        <Col sm="3" className="mt-2">
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="12">
                                            {this.state.audios.length > 0 && (
                                                !this.state.loaderAudio ? (

                                                    this.state.audios.map(audio => {
                                                        return (
                                                            <Row key={audio.id} className="my-4 align-items-center">
                                                                <Col sm="5">
                                                                    <audio className="w-100" controls>
                                                                        <source src={audio.src} />
                                                                    </audio>
                                                                </Col>
                                                                <Col sm="12" className="my-4 pl-4">
                                                                    <p>
                                                                        {audio.description}
                                                                    </p>
                                                                </Col>
                                                            </Row>
                                                        )
                                                    })

                                                ) : (<div className="d-flex justify-content-center p-4"> <Spin /></div>)
                                            )}

                                            {this.state.pages.length > 0 && (
                                                !this.state.loaderPages ? (
                                                    <Row>
                                                        {this.state.pages.map(page => {
                                                            return (
                                                                <Col sm="12" md="6" xl="4" key={page.id} className="my-4 align-items-center" >
                                                                    <Col sm="12" className="p-0">
                                                                        <iframe src={page.src + "#toolbar=0&zoom=0"} style={{ height: 250, width: "100%" }} frameBorder="0"> </iframe>
                                                                        <div className="openPdfBox">
                                                                            <a href={page.src} target="_blank"><Icon type="link" /> Open pdf</a>
                                                                        </div>
                                                                    </Col>
                                                                    <Col sm="12" className="my-4 pl-4">
                                                                        <p>
                                                                            {page.description}
                                                                        </p>
                                                                    </Col>
                                                                </Col>
                                                            )
                                                        })}
                                                    </Row>
                                                ) : (<div className="d-flex justify-content-center p-4"> <Spin /></div>)
                                            )}
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                {modal}
            </Container>


            )
    }

}



// WEBPACK FOOTER //
// ./src/FileMaker/Articles/DetailArticle.js